import { Link } from 'react-router-dom';
import { Building2, LifeBuoy, Mail, Shield } from 'lucide-react';
import { publicSupport } from '../../content/publicSite';

export const PublicFooter = () => {
  return (
    <footer className="border-t border-border bg-muted py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr_0.8fr]">
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center shadow-xs">
                <Building2 className="h-5 w-5 text-primary-foreground" />
              </div>
              <span className="text-lg font-bold text-foreground">BizCore</span>
            </div>
            <p className="max-w-md text-sm text-muted-foreground">
              Nepal-focused business software for invoicing, digital khata, inventory, payroll, and reporting — with guided rollout support for growing SMEs.
            </p>
            <p className="text-xs text-muted-foreground">{publicSupport.responseTime}</p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground mb-3">Need help?</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <a
                  className="inline-flex items-center gap-2 hover:text-foreground rounded-md transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-muted"
                  href={`mailto:${publicSupport.supportEmail}`}
                >
                  <LifeBuoy className="h-4 w-4" />
                  {publicSupport.supportEmail}
                </a>
              </li>
              <li>
                <a
                  className="inline-flex items-center gap-2 hover:text-foreground rounded-md transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-muted"
                  href={`mailto:${publicSupport.salesEmail}`}
                >
                  <Mail className="h-4 w-4" />
                  {publicSupport.salesEmail}
                </a>
              </li>
              <li>
                <a
                  className="inline-flex items-center gap-2 hover:text-foreground rounded-md transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-muted"
                  href={`mailto:${publicSupport.securityEmail}`}
                >
                  <Shield className="h-4 w-4" />
                  {publicSupport.securityEmail}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground mb-3">Explore</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-muted-foreground">
              <Link className="hover:text-foreground rounded-md transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-muted" to="/pricing">Pricing</Link>
              <Link className="hover:text-foreground rounded-md transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-muted" to="/resources">Resources</Link>
              <Link className="hover:text-foreground rounded-md transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-muted" to="/about">About</Link>
              <Link className="hover:text-foreground rounded-md transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-muted" to="/contact">Contact</Link>
              <Link className="hover:text-foreground rounded-md transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-muted" to="/security">Security</Link>
              <Link className="hover:text-foreground rounded-md transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-muted" to="/privacy">Privacy</Link>
              <Link className="hover:text-foreground rounded-md transition-colors motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-muted" to="/terms">Terms</Link>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-border pt-6 text-sm text-muted-foreground md:flex-row md:items-center md:justify-between">
          <p>&copy; 2026 BizCore. All rights reserved.</p>
          <p>Support and rollout details should be finalized before general launch.</p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
